import React from 'react';
import 'styles/play365/_loyaltyProgram.scss';
import 'styles/play365/_vipTeaser.scss';

// --- Data Structure for Tiers and Features ---
// GCC uses 5 tiers to match JPL: Iron → Copper → Bronze → Silver → Gold
const tiers = [
  { name: 'Iron', wager: '100', textClass: 'tier-iron-color', bgClass: 'tier-iron-bg', iconSrc: require('assets/play365/images/vip-madels/iron.webp') },
  { name: 'Copper', wager: '250', textClass: 'tier-copper-color', bgClass: 'tier-copper-bg', iconSrc: require('assets/play365/images/vip-madels/copper.webp') },
  { name: 'Bronze', wager: '500', textClass: 'tier-bronze-color', bgClass: 'tier-bronze-bg', iconSrc: require('assets/play365/images/vip-madels/bronze.webp') },
  { name: 'Silver', wager: '1,000', textClass: 'tier-silver-color', bgClass: 'tier-silver-bg', iconSrc: require('assets/play365/images/vip-madels/silver.webp') },
  { name: 'Gold', wager: '25,000', textClass: 'tier-gold-color', bgClass: 'tier-gold-bg', iconSrc: require('assets/play365/images/vip-madels/gold.webp') },
];

const features = [
  { name: 'Chat Access', tierIndex: 0, help: '24/7 access to the VIP chat room.' },
  { name: '0% Redeem Fee', tierIndex: 0, help: 'No fees when redeeming rewards.' },
  { name: 'Birthday Gift', tierIndex: 0, help: 'Special gift on your birthday.' },
  { name: 'Daily Reload', tierIndex: 0, help: 'Claimable cash reload daily based on recent activity.', isCoin: true },
  { name: 'Weekly Bonus', tierIndex: 1, help: 'A weekly reward based on your activity.', isCoin: true },
  { name: 'Monthly Bonus', tierIndex: 3, help: 'A substantial bonus paid out once per month.', isCoin: true, allowSweep: true },
  { name: 'VIP Tournaments', tierIndex: 3, help: 'Access to exclusive VIP tournaments.' },
  { name: 'Wheel Of Fortune', tierIndex: 3, help: 'Access to the Wheel of Fortune.' },
  { name: 'Unique Merchandise', tierIndex: 4, help: 'Exclusive merchandise and gifts.' },
  { name: 'VIP Host', tierIndex: 4, help: 'A dedicated account manager for personalized support.' },
  { name: 'Custom VIP Program', tierIndex: 4, help: 'A completely personalized rewards structure.' },
];

// Coin icons are a visual level indicator per tier (not a currency).
// Daily Reload: Iron(0), Copper(1), Bronze(2), Silver(3)=1, Gold(4)=2
const dailyReloadCoins = [1, 1, 1, 1, 2];

// Weekly Bonus: Iron(0)=0, Copper(1), Bronze(2)=1, Silver(3), Gold(4)=2
const weeklyBonusCoins = [0, 1, 1, 2, 2];

// Monthly Bonus: Iron(0), Copper(1), Bronze(2)=0, Silver(3)=3, Gold(4)=3
const monthlyBonusCoins = [0, 0, 0, 3, 3];

// --- Sub-Components ---
const FeatureCell = ({ tierIndex, featureIndex, feature }) => {
  const isAvailable = tierIndex >= featureIndex;

  if (!isAvailable) {
    return (
      <div className="table-cell feature-cell">
        <span>&nbsp;</span>
      </div>
    );
  }

  // Handle coin features
  if (feature.isCoin) {
    let coins = [];

    if (feature.name === 'Daily Reload') {
      coins = Array(dailyReloadCoins[tierIndex] || 0).fill('coin');
    } else if (feature.name === 'Weekly Bonus') {
      coins = Array(weeklyBonusCoins[tierIndex] || 0).fill('coin');
    } else if (feature.name === 'Monthly Bonus') {
      coins = Array(monthlyBonusCoins[tierIndex] || 0).fill('coin');
    }

    if (coins.length === 0) {
      return (
        <div className="table-cell feature-cell">
          <span>&nbsp;</span>
        </div>
      );
    }

    return (
      <div className="table-cell feature-cell coin-cell">
        {coins.map((coinType, idx) => (
          <img
            key={idx}
            src={require('assets/play365/images/coinSwitcher/fun-coin.svg').default}
            alt=""
            className={`coin-icon ${coinType}-coin`}
          />
        ))}
      </div>
    );
  }

  // Regular checkmark for non-coin features
  return (
    <div className="table-cell feature-cell">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 6L9 17L4 12" stroke="#4AC900" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
};

const TierHeader = ({ tier }) => (
  <div className="tier-header-cell">
    <div className={`tier-icon-wrapper ${tier.bgClass} ${tier.name}box`}>
      <img src={tier.iconSrc} className={tier.name} alt={tier.name} />
    </div>
    <div className={`tier-name ${tier.bgClass}`}>{tier.name}</div>
  </div>
);

// --- Main Component ---
const VIPRewardsTierTable = (props) => {
  const numTiers = tiers.length;
  const gridTemplateColumns = `200px repeat(${numTiers}, minmax(100px, 1fr))`;

  return (
    <div className="vip-tiers-table " id="vip-app-container">
      <div className="vip-table">
        <div className="vip-table-grid" style={{ gridTemplateColumns: gridTemplateColumns }}>
          {/* --- Rewards Tier Header Row --- */}
          <div className="vip-header header-cell-label tier-header-row" style={{ borderTopLeftRadius: '1rem' }}>
            <h2 className="rewards-tier-label">Rewards Tier</h2>
          </div>

          {tiers.map((tier, index) => (
            <div key={index} className="table-cell tier-header-row" style={{ borderLeft: '1px solid rgba(255, 255, 255, 0.1)' }}>
              <TierHeader tier={tier} />
            </div>
          ))}

          {/* --- Points Requirement Row --- */}
          <div className="vip-header header-cell-label feature-row">
            <span className="wager-label">Clover Points to reach</span>
          </div>

          {tiers.map((tier, index) => (
            <div key={index} className="table-cell feature-row">
              <span className={`wager-value ${tier.textClass}`}>
                {tier.wager}
                <small className="wager-unit">pts</small>
              </span>
            </div>
          ))}

          {/* --- Feature Rows --- */}
          {features.map((feature, featureIndex) => (
            <React.Fragment key={feature.name}>
              <div className="vip-header header-cell-label feature-row">
                <span className="feature-name">{feature.name}</span>
              </div>

              {tiers.map((tier, tierIndex) => (
                <div key={tier.name} className="table-cell feature-row">
                  <FeatureCell tierIndex={tierIndex} featureIndex={feature.tierIndex} feature={feature} />
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="vip-points-note" role="note">
        <span className="vip-points-note__ic" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <g transform="translate(12 11)">
              <ellipse cx="0" cy="-5" rx="3.4" ry="4.4" />
              <ellipse cx="4.4" cy="0" rx="4.4" ry="3.4" />
              <ellipse cx="0" cy="4.4" rx="3.4" ry="4.4" />
              <ellipse cx="-4.4" cy="0" rx="4.4" ry="3.4" />
              <rect x="-0.55" y="2.6" width="1.1" height="7" rx="0.55" />
            </g>
          </svg>
        </span>
        <p>
          <b>Clover Points</b> stack up automatically as you wager real money on
          any game — the more you play, the faster you climb. Points count toward
          your next tier and <b>never reset</b>, so every session moves you up the
          ladder.
        </p>
      </div>
    </div>
  );
};

export default VIPRewardsTierTable;

